import { useContext } from 'react';
import type { AuthContextType } from '../types';
import { AuthContext } from '../contexts/AuthContextDef';

/**
 * Hook to use auth context
 * 
 * This hook provides access to the authentication context.
 * Must be used within an AuthProvider.
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
